import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useRecentOrders() {
    const { data } = useQuery(queries.orders.recent());
    return data?.orders;
}

export default useRecentOrders;
